










































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { IStore } from "@/features/stores/api/store.interface";
import moment from "moment";

@Component({
  name: "salesReceipt"
})
export default class SalesReceipt extends Vue {
  // Lifecycle Functions
  mounted() {
    this.storeReceipts = this.receipts[this.$route.query.storeId];
    if (!this.storeReceipts || this.storeReceipts.length === 0) this.refresh();
  }

  // Getters
  @Getter("salesReceipt/salesReceipts")
  receipts: any;

  get getReceipts(): IDayDetails[] {
    return this.storeReceipts;
  }

  pagination: any = {};
  search: string = "";
  receiptsLoading: boolean = false;
  storeReceipts: IDayDetails[] = [];
  receiptHeaders: any[] = [
    {
      text: "Date",
      align: "left",
      sortable: true,
      value: "date"
    },
    {
      text: "Total Sales",
      align: "center",
      sortable: "false",
      value: "sales.salesRecord.totalSales"
    },
    {
      text: "Service Sales",
      align: "center",
      sortable: "false",
      value: "sales.salesRecord.serviceSales"
    },
    {
      text: "Product Sales",
      align: "center",
      sortable: "false",
      value: "sales.salesRecord.productSales"
    },
    {
      text: "Charge Receipt (Status)",
      align: "center",
      sortable: true,
      value: "charge.txnId"
    },
    {
      text: "Cash Receipt (Status)",
      align: "center",
      sortable: true,
      value: "cash.txnId"
    },
    {
      text: "Delete",
      align: "center",
      sortable: false,
      value: "date"
    }
  ];

  deleteReceipt(event: any, receipt: IDayDetails) {
    event.stopPropagation();
    var self = this;
    self.receiptsLoading = true;
    this.$store
      .dispatch("salesReceipt/delete", {
        storeId: this.$route.query.storeId,
        date: receipt.date
      })
      .then(() => {
        self.receiptsLoading = false;
      })
      .catch(() => {
        self.receiptsLoading = false;
      });
  }

  refresh() {
    console.log("Getting sales reciepts");
    var self = this;
    self.receiptsLoading = true;
    this.$store
      .dispatch("salesReceipt/getForStore", this.$route.query.storeId)
      .then(() => {
        self.receiptsLoading = false;
        self.storeReceipts = self.receipts[this.$route.query.storeId];
      })
      .catch(() => {
        self.receiptsLoading = false;
      });
  }
}
